import i18n from '@/plugins/i18n';

export const integrationType = () => {
    return [{
            id: 1,
            text: i18n.t('Simple Variation'),
            badgeColor: 'bg-primary-300',
            icon: 'fas fa-box-alt ',
            style: ' width:20px; height:20px; line-height:20px'
        },
        {
            id: 2,
            text: i18n.t('Configurable Variation'),
            badgeColor: 'bg-teal-300',
            icon: 'fad fa-box-check',
            style: ' width:20px; height:20px; line-height:20px'
        }
    ];
}

export const statusOptions = () => {
    return [{
            id: 1,
            text: i18n.t('Active'),
        },
        {
            id: 2,
            text: i18n.t('_Variation.Draft'),
        },
        {
            id: 3,
            text: i18n.t('_Variation.Archived'),
        }
    ];
}

export const defaultsortOrder = () => {
    return [{
        field: 'create_date',
        direction: 'DESC'
    }]
}

export const dateFormatPicker = () => {
    return 'dd/mm/yyyy';
}

export const dateFormatMoment = () => {
    return 'DD/MM/YYYY';
}

export const titleName = (type) => {
    let title = "";
    switch (type) {
        case 1:
            title = "Create New Simple Variation"
            break;
        case 2:
            title = "Create New Configurable Variation"
            break;
        case 'edit':
            title = "Edit Variation"
            break;
        default:
            title = "Create Variation"
    }
    return i18n.t(title);
}


// WEBPACK FOOTER //
// ./src/components/tenancy/admin/settings/sale/sale-contact/Params.js